// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__cSRJ8","search":"Settings_search__1Qg3U","filter":"Settings_filter__3CMQz"};